module.exports = __webpack_public_path__ + "static/img/lab.d38e76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lab.png
// module id = PKOI
// module chunks = 1